package app.view

import app.CustomRouter
import app.Routes
import app.api.RolloutExecutionsPaginatedApi
import app.components.pagination
import app.components.sidebarNavigation
import app.svg.*
import app.utils.formatDateTime
import app.utils.getDarkStatusBackgroundColor
import dev.fritz2.core.*

fun RenderContext.rolloutExecutions(
    rolloutExecutionsPaginatedApi: RolloutExecutionsPaginatedApi,
    projectId: String?,
    page: Int,
    sort: String,
    order: String,
) {
    if (projectId == null) {
        CustomRouter.navTo(mapOf("route" to Routes.PROJECTS))
        return
    }
    rolloutExecutionsPaginatedApi.handler(
        RolloutExecutionsPaginatedApi.PaginationRequest(
            projectId = projectId,
            sort = sort,
            order = order,
            page = page,
        )
    )
    rolloutExecutionsPaginatedApi.data.render { paginatedResponse ->
        div("flex gap-4 dark:text-white") {
            sidebarNavigation(projectId)
            div("basis-10/12 border rounded-md shadow-md my-4 p-4 dark:bg-gray-800 dark:border-gray-700") {
                h3("font-semibold p-2") {
                    +"Rollouts"
                }
                div("relative overflow-x-auto shadow-md sm:rounded-lg mt-4 border dark:border-gray-700") {
                    table("w-full text-sm text-left text-gray-500 dark:text-gray-400") {
                        thead("text-xs text-gray-700 bg-gray-50 dark:bg-gray-600 dark:text-gray-300") {
                            tr {
                                th("px-6 py-3") {
                                    scope("col")
                                    +"STATUS"
                                }
                                th("px-6 py-3") {
                                    scope("col")
                                    button("flex items-center ${if (sort == "version") "underline" else ""}") {
                                        +"VERSION"
                                        sort("w-3 h-3 ms-1.5")
                                        clicks handledBy {
                                            CustomRouter.rollouts(
                                                mapOf(
                                                    "route" to Routes.ROLLOUTS,
                                                    Routes.Params.PROJECT_ID to projectId,
                                                    Routes.Params.SORT to "version",
                                                    Routes.Params.ORDER to if (order == "asc") "desc" else "asc",
                                                    Routes.Params.PAGE to "1"
                                                )
                                            )
                                        }
                                    }
                                }
                                th("px-6 py-3") {
                                    scope("col")
                                    button("flex items-center ${if (sort == "date") "underline" else ""}") {
                                        +"STARTED AT"
                                        sort("w-3 h-3 ms-1.5")
                                        clicks handledBy {
                                            CustomRouter.rollouts(
                                                mapOf(
                                                    "route" to Routes.ROLLOUTS,
                                                    Routes.Params.PROJECT_ID to projectId,
                                                    Routes.Params.SORT to "date",
                                                    Routes.Params.ORDER to if (order == "asc") "desc" else "asc",
                                                    Routes.Params.PAGE to "1"
                                                )
                                            )
                                        }
                                    }
                                }
                                th("px-6 py-3") {
                                    scope("col")
                                    +"FINISHED AT"
                                }
                                th("px-6 py-3") {
                                    scope("col")
                                    +"TARGET"
                                }
                            }
                        }
                        tbody {
                            paginatedResponse.items.forEach { rolloutExecution ->
                                tr("bg-white hover:bg-gray-200 cursor-pointer border-b group dark:bg-gray-700 dark:border-gray-700 dark:hover:bg-gray-600") {
                                    clicks handledBy {
                                        CustomRouter.rollout(
                                            mapOf(
                                                "route" to Routes.ROLLOUT,
                                                Routes.Params.PROJECT_ID to projectId,
                                                Routes.Params.ROLLOUT_ID to rolloutExecution.id.toString(),
                                            )
                                        )
                                    }
                                    td("px-6 py-4 flex") {
                                        div(
                                            "text-xs text-white rounded-full px-1 ${
                                                getDarkStatusBackgroundColor(
                                                    rolloutExecution
                                                )
                                            }"
                                        ) {
                                            +rolloutExecution.status
                                        }
                                    }
                                    td("px-6 py-4") {
                                        div {
                                            +rolloutExecution.version.toString()
                                        }
                                    }
                                    td("px-6 py-4") {
                                        +formatDateTime(rolloutExecution.startedAt)
                                    }
                                    td("px-6 py-4") {
                                        +formatDateTime(rolloutExecution.finishedAt)
                                    }
                                    td("px-6 py-4 flex gap-1 text-xs") {
                                        div("bg-blue-500 text-white rounded-full px-1") {
                                            +rolloutExecution.stageName
                                        }
                                        div("bg-gray-500 text-white rounded-full px-1") {
                                            +rolloutExecution.companyName
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                div("mt-4 flex justify-center") {
                    pagination(
                        currentPage = paginatedResponse.currentPage,
                        totalPages = paginatedResponse.totalPages
                    ) { newPage ->
                        CustomRouter.rollouts(
                            mapOf(
                                "route" to Routes.ROLLOUTS,
                                Routes.Params.PROJECT_ID to projectId,
                                Routes.Params.SORT to sort,
                                Routes.Params.ORDER to order,
                                Routes.Params.PAGE to newPage.toString()
                            )
                        )
                    }
                }
            }
        }
    }
}
